import React, { useState, useEffect, useCallback, useMemo } from 'react'
import {StickyHeadTable, CustomTableCell, MuiPaper} from '../../Utils/Tables/StickyHeaderTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList } from '@fortawesome/free-solid-svg-icons/faClipboardList';
import PageTitle from '../../Utils/smsTitle';
import { SubHeader } from '../../../Containers/SubHeader';
import { dateConvert, formatDateTime } from '../../Utils/ConvertDate';
import axios from 'axios';
import { config } from "../../../Helpers/env"
import { errorMessages, logoutErrorMessage } from '../../../Helpers/ErrorMessages';
import * as snackbarActions from "../../../actions/snackbarActions";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import MainSnackbar from '../../Utils/Snackbar/SmsSnackbar';
import { DateTimeFilter } from '../../Utils/ReusableComponents/DateTimeFilter';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { LoadingGif } from '../../Utils/Loader';
import ReusableTabs, {TabPanel} from '../../Utils/Dialogs/ReusableTabs';
import { todayTime } from '../../Utils/ConvertDate';
import {BackButton, DataExportButton} from '../../Utils/Buttons/DataExportationButton';
import Label from "../../Utils/FormInputs/Label";
import { AutoCompleteControlled } from '../../Utils/FormInputs/AutoCompleteInput';
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Link} from "react-router-dom";
import {useExcelReports, usePdfDownload} from "../../Utils/ReusableComponents/useExcelExport";
import {CustomTablePagination, EnhancedSearchTableToolbar} from "../../Utils/Tables/CustomTable";
import {useCurrency} from "../../../Context/currency-context";
import { useVersionsContext } from '../../../Context/versions-context';

function TotalRevenueGeneratedReport({actions, snackbars}) {
    useCurrency({actions, snackbars})
    const current_date = todayTime()
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [activePage, setActivePage] = React.useState(1);
    const [state, setState] = useState({start_date:dateConvert(), end_date:dateConvert()})
    const [revenues, setRevenues] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState('idle');
    const [loading, setLoading] = useState('idle')
    const {start_date, end_date} = state;
    const [tabValue, setTabValue] = useState(0)
    const [totalGrandCollections, setTotalGrandCollections] = useState('')
    const [total_count, setTotalCount] = useState(0)
    const [providerOptions, setProviderOptions] = useState([]);
    const [insurance_provider, setInsuranceProvider] = useState(null);
    const [receivedbyOptions, setReceivedbyOptions] = useState([])
    const [received_by, setReceivedBy] = useState({value:'',label:''})
    const isCredit = tabValue === 2 || tabValue === 0;
    const [search, setSearch] = useState('')
    // const storedUser = JSON.parse(sessionStorage.getItem("user") || "{}");
    // const userData = storedUser?.token?.[1] || {};
    // const roleName = typeof userData.role_name === "string" ? userData.role_name.trim().toLowerCase() : "";
    // const hasReportAccess = roleName === "admin" || roleName === "auditor" || roleName === "front desk" || roleName === "cashier" || roleName === "accountant" || roleName === "superadmin";

    const {subscription} = useVersionsContext()
    const version = subscription?.version

    const bill_mode = useMemo(() => ({
        0:'all',
        1:'cash',
        2:'account',
        3:'inpatient_deposits'
    }), [])

    const headData = [
        {id: 'count', label: 'Sl'},
        {id: 'visit_date', label: tabValue === 3 ? 'Deposit Date' : 'Visit Date'},
        {id: 'visit', label: 'Visit No.',},
        isCredit !== true ? {id: 'receipt_no',label: 'Receipt'} : null,
        {id: 'patient_number', label: 'Patient No.'},
        tabValue !== 3 ? {id: 'patient_type', label: 'Patient Type'} : null,
        {id: 'patient_name',label: 'Patient Name',},
        {id: 'total_amount',label: tabValue === 3 ? 'Amount Deposited' : 'Total Bill'},
        isCredit ? {id: 'provider_name',label: 'Provider Name'} : null,
        isCredit ? {id: 'member_card_no',label: 'Member Card No.'} : null,
      ]

    const retrieveData = useCallback(() => {
        // if (!hasReportAccess) {
        //     return
        // }

        const params = {
            start_date,
            end_date,
            bill_mode: bill_mode[tabValue],
            download: false,
            provider_id: (tabValue === 2) ? (insurance_provider?.value ? insurance_provider.value : '') : '',
            received_by: received_by?.value ? received_by.value : '',
            page: activePage,
            search,
            per_page: rowsPerPage
        }

        setLoading('pending')
        axios.get(`${config.smsUrl}/cbilling/collections`, {params}).then(response => {
            const res = response.data ? response.data : {};
            const data = res.data ? res.data : [];
            const grand_total_amount = res.grand_total_amount ? res.grand_total_amount : 0;
            const count = res.count ? res.count : 0;
            setTotalCount(count)
            setRevenues(data)
            setTotalGrandCollections(grand_total_amount)
            setLoading('success')
        }).catch(err => {
            logoutErrorMessage(err, null, actions)
            setLoading('error')
        })
    }, [actions, bill_mode, end_date, 
        // hasReportAccess, 
        insurance_provider, received_by, activePage, rowsPerPage, search, start_date, tabValue])

    useEffect(() => {
        setActivePage(1)
        setPage(0)
        setRowsPerPage(50)
    }, [tabValue]);

    useEffect(() => {
        retrieveData()
    }, [retrieveData])

    useEffect(() => {
        // if (!hasReportAccess) {
        //     return
        // }

        if (tabValue !== 2) {
            if (insurance_provider && insurance_provider.value) {
                setInsuranceProvider(null)
            }
            return
        }

        axios.get(`${config.smsUrl}/cbilling/insurance_providers/list`).then(res => {
            const data = res.data;
            const dt = !data ? {} : data;
            const arr = !dt.data ? [] : dt.data;
            const provs = arr.map(item => ({
                ...item,
                value: item.provider_id,
                label: item.provider_name
            }));
            setProviderOptions(provs);
        }).catch(err => {
            logoutErrorMessage(err, null, actions)
        })
    }, [actions, 
        // hasReportAccess, 
        insurance_provider, tabValue]);

    useEffect(() => {
        // if (!hasReportAccess) {
        //     return
        // }

        if (tabValue !== 1) {
            if (received_by && received_by.value) {
                setReceivedBy({value: '', label: ''})
            }
            return
        }

        axios.post(`${config.smsUrl}/permission/user_roles_list`).then(res => {
            const data = res.data;
            const dt = !data ? {} : data;
            const arr = !dt.user_roles_list ? [] : dt.user_roles_list;
            const provs = arr.map(item => ({
                ...item,
                value: item.user_roles_id,
                label: `${item.first_name} ${item.last_name}`
            }));
            setReceivedbyOptions(provs);
        }).catch(err => {
            logoutErrorMessage(err, null, actions)
        })
    }, [actions, 
        // hasReportAccess, 
        received_by, tabValue]);
  
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        setActivePage(newPage + 1);
    };
  
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        setActivePage(1);
    };

    const handleProviderChange = (value) => {
        setInsuranceProvider(value);
    }

    const handleChangeReceivedBy = (value) => {
        setReceivedBy(value)
    }

    const handleChange = (event) => {
        const {value, name} = event.target;
        setState({...state,[name]:value})
    }

    const handleSubmit = (event) => {
        event.preventDefault()

        setSubmitted(true)
        if (start_date && end_date && end_date >= start_date) {
            setIsSubmitted('pending')
            setLoading('pending')
            axios.get(`${config.smsUrl}/cbilling/collections`, {params:{start_date, end_date,
                bill_mode: bill_mode[tabValue],
                download: false,
                provider_id: (tabValue === 2) ? (insurance_provider?.value ? insurance_provider.value : '') : '',
                received_by: received_by?.value ? received_by.value : '',
                page: activePage,
                per_page: rowsPerPage
            }}).then(response => {
                const res = response.data ? response.data : {};
                const data = res.data ? res.data : [];
                const grand_total_amount = res.grand_total_amount ? res.grand_total_amount : 0;
                const count = res.count ? res.count : 0;
                setTotalCount(count)
                setRevenues(data)
                setTotalGrandCollections(grand_total_amount)
                setLoading('success')
                setIsSubmitted('resolved')
            }).catch(err => {
                errorMessages(err, null, actions)
                setLoading('error')
                setIsSubmitted('rejected')
            })
        }
    }

    const fileName = {
        0:'All Collections',
        1:'Cash Collections',
        2:'Credit Collections',
        3:'Inpatient Deposits'
    }

    const handleChangeTabValue = (event, val) => {
        if (event && typeof event.preventDefault === 'function') {
            event.preventDefault()
        }
        setTabValue(val)
    }

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar()
    };

    const isLoading = loading === 'pending';
    const isSuccess = loading === 'success';
    const isError = loading === 'error';
    
    const isPending = isSubmitted === 'pending';
    const {openBar, type, message} = snackbars;

    const colSpan = headData.length

    const total_text = {
        0:'Collections',
        1:'Cash Collections',
        2:'Credit Collections',
        3:'Inpatient Deposits'
    }

    const pagination = (
        <CustomTablePagination
            colSpan={3}
            page={page}
            rowsPerPage={rowsPerPage}
            count={total_count}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            isTotalCount
        />
    );

    const params = {
        start_date,
        end_date,
        bill_mode: bill_mode[tabValue],
        download: true,
        provider_id: (tabValue === 2) ? (insurance_provider?.value ? insurance_provider.value : '') : '',
        received_by: received_by?.value ? received_by.value : '',
        page: activePage
    }

    const {exportExcel, isLoading: isLoadingExcel} = useExcelReports(actions,{file_name:`${fileName[tabValue]}-${current_date}`, url:`cbilling/collections`, params:{...params, download_type:1}})
    const {exportPdf, isLoading: isLoadingPdf} = usePdfDownload(actions,{file_name:`${fileName[tabValue]}-${current_date}`, url:`cbilling/collections`, params:{...params, download_type:2}})

    const handleSearch = (event) => {
        setSearch(event.target.value)
    }

    const reusableTable = (
        <div className='mt-3'>
            {
                total_text[tabValue] === 'Credit Collections' ? (
                    <div>
                        <div className='col-lg-6'>
                            <Form.Group as={Row}>
                                <Col xs={12} sm={12} md={12} lg={2} xl={2}>
                                    <Label name="Filter by" type/>
                                </Col>

                                <Col xs={12} sm={12} md={12} lg={7} xl={7}>
                                    <AutoCompleteControlled options={providerOptions} medicine_value={insurance_provider} handleChange={handleProviderChange}
                                        placeholder="Filter by provider..." dataTest="filter_by_provider"
                                        value_text='value' label_text='label' />
                                </Col>
                            </Form.Group>
                        </div>
                        <div className='text-xl-right text-lg-right text-md-left text-sm-left'>
                            <h5>{`Total ${total_text[tabValue]}`} : <strong>{totalGrandCollections}</strong></h5>
                        </div>
                    </div>
                ) : total_text[tabValue] === 'Cash Collections' ? (
                    <div>
                        <div className='col-lg-6'>
                            <Form.Group as={Row}>
                                <Col xs={12} sm={12} md={12} lg={2} xl={2}>
                                    <Label name="Filter by" type/>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={8} xl={8}>
                                    <AutoCompleteControlled options={receivedbyOptions} handleChange={handleChangeReceivedBy}
                                        placeholder="Filter by receiver..." dataTest="received_by" medicine_value={received_by}
                                        value_text='value' label_text='label' />
                                </Col>
                            </Form.Group>
                        </div>
                        <div className='text-xl-right text-lg-right text-md-left text-sm-left'>
                            <h5>{`Total ${total_text[tabValue]}`} : <strong>{totalGrandCollections}</strong></h5>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className='text-xl-right text-lg-right text-md-left text-sm-left'>
                            <h5>{`Total ${total_text[tabValue]}`} : <strong>{totalGrandCollections}</strong></h5>
                        </div>
                    </>
                )
            }
            <MuiPaper>
                <EnhancedSearchTableToolbar term={search} handler={handleSearch}/>
                <StickyHeadTable {...{page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, data: revenues, columns: headData.filter(item => Boolean(item)), pagination}}>
                    {isLoading ? <TableRow><TableCell align='center' {...{colSpan}}><LoadingGif/></TableCell></TableRow> : null}
                    {isSuccess ? revenues.length > 0 ?
                        <>
                            {revenues.slice(0, rowsPerPage).map((row, index) => {
                                const patient_name = `${row.first_name ? row.first_name : ''} ${row.last_name ? row.last_name : ''}`
                                const url = start_date && end_date ? `/patient-transactions/${row.visit_id}-${patient_name}/${tabValue}/${start_date}/${end_date}` :
                                    `/patient-transactions/${row.visit_id}-${patient_name}/${tabValue}`
                                const count = ((activePage - 1) * rowsPerPage) + (index + 1)
                                return (
                                    <TableRow tabIndex={-1} key={index}>
                                        <CustomTableCell>{count}</CustomTableCell>
                                        <CustomTableCell>{row.begin_datetime ? formatDateTime(row.begin_datetime) : null}</CustomTableCell>
                                        <CustomTableCell>{row.visit_id}</CustomTableCell>
                                        {isCredit !== true ? <CustomTableCell>{row.receiptno}</CustomTableCell> : null}
                                        <CustomTableCell>{row.patient_number}</CustomTableCell>
                                        {tabValue !== 3 ? <CustomTableCell>{row.patient_type === 1 ? "Out Patient" : "Inpatient"}</CustomTableCell> : null}
                                        <CustomTableCell>
                                            <Link to={{pathname: url}}>{patient_name}</Link>
                                        </CustomTableCell>
                                        <CustomTableCell>{(row.total_amount)}</CustomTableCell>
                                        {isCredit ? <CustomTableCell>{row.billed_to}</CustomTableCell> : null}
                                        {isCredit ? <CustomTableCell>{row.card_number}</CustomTableCell> : null}
                                    </TableRow>
                                );
                            })}
                        </> : <TableRow><TableCell align='center' {...{colSpan}}>No records found</TableCell></TableRow> : null}
                    {isError ? <TableRow><TableCell align='center' {...{colSpan}}>The server did not return a valid response</TableCell></TableRow> : null}
                </StickyHeadTable>
            </MuiPaper>
        </div>
    )

    const tabs = ['All Collections', 'Cash Collections', 'Credit Collections', 'Inpatient Deposits']
    const tabsStandard = ['All Collections', 'Cash Collections']

    // if (!hasReportAccess) {
    //     return (
    //         <>
    //             <PageTitle title="Access Denied" />

    //             <SubHeader
    //                 title="Reports"
    //                 subTitle="Access Denied"
    //             >
    //                 <FontAwesomeIcon icon={faClipboardList}/>
    //             </SubHeader>

    //             <div className="container-fluid mt-4 px-3">
    //                 <div className="text-center mt-5">
    //                     <h5>Access Denied</h5>
    //                     <p>
    //                         You do not have permission to view the
    //                         Revenue Generated report.
    //                     </p>
    //                 </div>
    //             </div>
    //         </>
    //     );
    // }

    return (
        <div className='journals'>
            <PageTitle title='Revenue Generated'/>
            <SubHeader title="Reports" subTitle='Revenue Generated'>
                <FontAwesomeIcon icon={faClipboardList}/>
            </SubHeader>
            <MainSnackbar variant={type} open={openBar} message={message} handleCloseBar={closeSnackbar}/>
            <div className='mx-3'>
                <div style={{margin: '10px'}}>
                    <BackButton text={'General Reports'} to={'/reports/generalreports'}/>
                </div>

                <div className='general-ledger-header' style={{marginBottom:0, display:'flex', justifyContent:'space-between', flexWrap:'wrap'}}>
                    <DateTimeFilter {...{start_date, end_date, handleChange, submitted, handleSubmit, isPending, type: 'date'}}/>
                    <div style={{margin: '10px'}}>
                        <DataExportButton exportCsv={exportExcel} isLoading={isLoadingExcel || isLoadingPdf} downLoadPdf={exportPdf}/>
                    </div>
                </div>
                <ReusableTabs value={tabValue} tabHeading={version === 'Premium' ? tabs : tabsStandard} handleChange={handleChangeTabValue}>
                    <TabPanel value={tabValue} index={0}>
                        {reusableTable}
                    </TabPanel>
                    <TabPanel value={tabValue} index={1}>
                        {reusableTable}
                    </TabPanel>
                    <TabPanel value={tabValue} index={2}>
                        {reusableTable}
                    </TabPanel>
                    <TabPanel value={tabValue} index={3}>
                        {reusableTable}
                    </TabPanel>
                </ReusableTabs>
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    return {snackbars: state.snackbar}
}

function mapDispatchToProps(dispatch) {
    return {actions: {snackbarActions: bindActionCreators(snackbarActions, dispatch)}}
}

export default connect(mapStateToProps, mapDispatchToProps)(TotalRevenueGeneratedReport);
